module.exports = __webpack_public_path__ + "static/media/43.54eae5bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/43.png
// module id = 615
// module chunks = 0